import { Injectable } from '@angular/core';
import { Agency } from '@ag-common-lib/public-api';
import { BaseFormService } from '../../../../utils/base-form-service';

@Injectable()
export class UpdateAgencyLeadModalService extends BaseFormService<any> {
  constructor() {
    super();
  }

  getFormData = (agency: Agency) => {
    this.formChangesDetector.clear();
    const initialData = {};

    const formData = new Proxy(initialData, {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];

        if (value !== prevValue) {
          this.formChangesDetector.handleChange(prop, value, prevValue);
          Reflect.set(target, prop, value, receiver);

          this.formDataSig.update(data => data);

          // switch (prop) {
          //   case AgencyKeys.agencyType:
          //     const mga = value === AGENCY_TYPE.MGA ? (agency.agency_id ?? null) : agency.mga;
          //     Object.assign(this.formData, { [AgencyKeys.mga]: mga });
          //     break;
          // }
        }
        return true;
      },
    });

    this.formDataSig.set(formData);
  };
}
